import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { initTheme } from './utils/themes';
import { register as registerSW } from './serviceWorkerRegistration';

initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for offline caching and fast repeat loads.
// Only activates in production (build output), no-op in dev server.
registerSW();
